/**
 * 12.评级变动对比列表，展示资产从旧评级到新评级的变化。 Figma：81033:19165
 */

import { Icon, ospThemes } from "@ospweb/sdk-ui";

import { cn } from "utils";
import log from "logbeacon";
import { useCallback } from "react";
import { ChatAssetInline } from "../StructuredCards/common/ChatAssetInline";
import { ChatSignalTag } from "../StructuredCards/common/ChatSignalTag";
import type { RatingChange } from "./type";

export interface AssetRatingChangeComparisonListProps {
  changes: RatingChange[];
}

export const AssetRatingChangeComparisonList: React.FC<
  AssetRatingChangeComparisonListProps
> = ({ changes }) => {
  const onClickRow = useCallback((change: RatingChange) => {
    log.debug("[onClickRow]", change.assetLogo);
  }, []);
  return (
    <div className="flex flex-col">
      {changes.map((row, ri) => (
        <button
          key={row.id ?? `${row.assetSymbol}-${ri}`}
          type="button"
          className={cn(
            "relative flex h-12 w-full items-stretch border-b border-border_white_transparent10 text-left last:border-b-0",
          )}
          data-openreplay-label={`AssetRatingChangeComparisonList · Row | ${row.assetSymbol}`}
          onClick={() => onClickRow(row)}
        >
          <div className="flex min-w-0 flex-1 items-center gap-2 px-2 py-1.5">
            <ChatAssetInline
              asset={{
                ...(row.id !== undefined && row.id !== ""
                  ? { id: row.id }
                  : {}),
                imageUrl: row.assetLogo || "",
                symbol: row.assetSymbol,
                schemaAssetType: row.type,
              }}
              size="md"
              symbolClassName="body_medium_m text-content_secondary"
            />
          </div>
          {[row.fromRating, row.toRating].map((sig, index) => (
            <div
              key={index}
              className={cn(
                "flex min-w-0 flex-1 px-2 py-1.5",
                index === 0
                  ? "items-center gap-1"
                  : "items-center justify-center",
              )}
            >
              {index === 0 ? (
                <>
                  {/* Flex reserves width for arrow; label is not clipped (no ellipsis). */}
                  <div className="flex min-w-0 flex-1 items-center justify-center">
                    <ChatSignalTag label={sig} />
                  </div>
                  <span
                    aria-hidden
                    className="pointer-events-none flex shrink-0 items-center"
                  >
                    <Icon
                      name="right-arrow-alt"
                      size={16}
                      color={ospThemes.colors.content_tertiary}
                    />
                  </span>
                </>
              ) : (
                <ChatSignalTag label={sig} />
              )}
            </div>
          ))}
        </button>
      ))}
    </div>
  );
};
